<template>
  <vx-card :title="$t('reports.mental_health.'+category+'.title')">
    <vs-row v-if="extractedData" vs-align="center" vs-justify="center">
      <vs-col vs-w="4">
        <div class="p-1 text-center">
          <div class="truncate"><h3 class="mb-1"><span class="font-bold">{{ formatter(extractedData.average) }}</span> / {{ maxValue }}</h3>
            <span>{{ $t('reports.global.avg') }}</span></div>
        </div>
      </vs-col>
      <vs-col vs-w="4">
        <div class="p-1 text-center">
          <div class="truncate"><h3 class="mb-1"><span class="font-bold">{{ formatter(extractedData.min) }}</span> / {{ maxValue }}</h3>
            <span>{{ $t('reports.global.min') }}</span></div>
        </div>
      </vs-col>
      <vs-col vs-w="4">
        <div class="p-1 text-center">
          <div class="truncate"><h3 class="mb-1"><span class="font-bold">{{ formatter(extractedData.max) }}</span> / {{ maxValue }}</h3>
            <span>{{ $t('reports.global.max') }}</span></div>
        </div>
      </vs-col>
      <vs-col vs-w="8">
        <vue-apex-charts height="200" type="bar" :options="extractedData.chartOptions" :series="extractedData.series"></vue-apex-charts>
      </vs-col>
    </vs-row>
  </vx-card>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine';

const scoreConfiguration = [
  ['HH', 'Healthy: High Average', '#039c88'],
  ['HA', 'Healthy: Average', '#27ae60'],
  ['HL', 'Healthy: Low Average', '#67A88A'],
  ['BL', 'Borderline', '#ffb729'],
  ['ML', 'Mild', '#ffd04f'],
  ['MO', 'Moderate', '#ff8884'],
  ['SE', 'Severe', '#eb4d55']
];

const scoreLevels = scoreConfiguration.map(sl => sl[0]);
const scoreLevelsLabels = scoreConfiguration.map(sl => sl[1]);
const colors = scoreConfiguration.map(sl => sl[2]);


export default {
  name: 'mental-health-category-card',
  components: {StatisticsCardLine},
  props: {
    data: Object,
    category: String,
    maxValue: Number,
    formatter: {
      type: Function,
      required: false,
      default (value) {
        if (isFinite(value)) {
          return value;
        }
        return 0;
      }
    }
  },
  data () {
    return {
      extractedData: null
    };
  },
  watch: {
    data: {
      immediate: true,
      handler (value) {
        const root = value.analysis.find(n => n.name === 'ROOT');
        const allTime = root.nested.find(n => n.name === 'ALL_TIME');
        const category = allTime.nested.find(n => n.name === this.category);
        const categoryStats = allTime.nested.find(n => n.name === `${this.category}_STATS`);
        this.extractedData = {
          average: Number.parseFloat(categoryStats.avg).toFixed(1).replace(/\.0$/, ''),
          min: Number.parseFloat(categoryStats.min).toFixed(1).replace(/\.0$/, ''),
          max: Number.parseFloat(categoryStats.max).toFixed(1).replace(/\.0$/, ''),
          series: [
            {
              name: this.$t(),
              data: scoreLevels.map(scoreLevel => {
                const bucket = category.buckets.find(b => b.key === scoreLevel);
                return bucket ? bucket.count : 0;
              })
            }
          ],
          chartOptions: {
            colors,
            chart: {
              type: 'bar',
              toolbar: {
                show: false
              }
            },
            plotOptions: {
              bar: {
                borderRadius: 25,
                columnWidth: '80%',
                horizontal: false,
                distributed: true
              }
            },
            tooltip: {
              y: {
                formatter: value => {
                  return value.toFixed(0);
                }
              }
            },
            grid: {
              show: false
            },
            fill: {
              opacity: .8
            },
            dataLabels: {
              enabled: false
            },
            legend: {
              show: false
            },
            xaxis: {
              categories: scoreLevelsLabels,
              labels: {
                show: false
              },
              axisTicks: {
                show: false
              }
            },
            yaxis: {
              axisTicks: {
                show: false
              },
              axisBorder: {
                show: false
              },
              labels: {
                show: false
              }
            }
          }
        };
      }
    }
  }
};
</script>

<style scoped>

</style>
